import React from 'react'
import './Benefits.css'
import { images } from '../../assets'

function Benefits() {

    const data=[
        {
            id:1,
            img:images.people,
            title:"Build an emotional connect with your people",
            percentage:"99%",
            text:"of employees say they feel connected to company’s social mission"

        },
        {
            id:2,
            img:images.employee,
            title:"Boost employee engagement & productivity",
            percentage:"92%",
            text:"of employees feel more active & productive at work"

        },
        {
            id:3,
            img:images.healthcare,
            title:"Save costs on healthcare & absenteeism",
            percentage:"75%",
            text:"of employees say they feel healthy & lose weight"

        }
    ]
  return (
    <div className='benefits' >
        <div className='benefitsBox'>
            <div className='benefitTitle'>What are the benefits?</div>
            <div className='benefitCardBox'>
            {
                data.map((data,id)=>(
                    <div key={id} className='benefitCard'>
                        <img src={data.img} alt="People" />
                        <div className='benefitCardContent'>
                        <div className='benefitReviewTitle'>{data.title}</div>
                        <div className='benefitReview'>
                            <div className='percentage'>{data.percentage}</div>
                            <div className='benefitReviewText'>{data.text}</div>
                        </div>
                        </div>
                    </div>
                ))
            }
            </div>    
        </div>  
    </div>
  )
}

export default Benefits
